import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  bullets: { id: number }
  secondaryButton: {}
  mainButton: {}
}>('wix-vibe-bullet-split')
